import { WellsDataApi, WellsDataService } from '@repo/core/wells-data-service';

import { wellDirectoryServiceAgent } from 'src/api/well-directory-service-agent';
import type { IServicesCollection } from 'src/packages/di';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    wellsData: WellsDataService;
  }
}

export function addWellsDataService(di: IServicesCollection): void {
  di.addSingleton(
    'wellsData',
    new WellsDataService(new WellsDataApi(wellDirectoryServiceAgent), di.requireService('directories')),
  );
}
